/**
 * Mapbox Configuration
 * Centralized configuration for Mapbox GL JS integration
 */

// Mapbox Access Token
export const MAPBOX_ACCESS_TOKEN = process.env.NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN;

// Default Map Styles
export const MAP_STYLES = {
  streets: 'mapbox://styles/mapbox/streets-v12',
  outdoors: 'mapbox://styles/mapbox/outdoors-v12',
  light: 'mapbox://styles/mapbox/light-v11',
  dark: 'mapbox://styles/mapbox/dark-v11',
  satellite: 'mapbox://styles/mapbox/satellite-v9',
  satelliteStreets: 'mapbox://styles/mapbox/satellite-streets-v12'
} as const;

// Default Map Configuration
export const DEFAULT_MAP_CONFIG = {
  center: [-122.4194, 37.7749] as [number, number], // San Francisco
  zoom: 11,
  style: MAP_STYLES.streets
} as const;

// Route Map Configuration
export const ROUTE_MAP_CONFIG = {
  center: [-122.4194, 37.7749] as [number, number],
  zoom: 13,
  style: MAP_STYLES.outdoors // Better for route visualization
} as const;

// Map Style Options for UI
export const STYLE_OPTIONS = [
  { value: MAP_STYLES.streets, label: 'Streets' },
  { value: MAP_STYLES.outdoors, label: 'Outdoors' },
  { value: MAP_STYLES.light, label: 'Light' },
  { value: MAP_STYLES.dark, label: 'Dark' },
  { value: MAP_STYLES.satellite, label: 'Satellite' },
  { value: MAP_STYLES.satelliteStreets, label: 'Satellite Streets' }
] as const;

// Validate Mapbox token
export const validateMapboxToken = (): boolean => {
  if (!MAPBOX_ACCESS_TOKEN) {
    console.error('NEXT_PUBLIC_MAPBOX_ACCESS_TOKEN is not set in environment variables');
    return false;
  }
  
  if (!MAPBOX_ACCESS_TOKEN.startsWith('pk.')) {
    console.error('Invalid Mapbox access token format');
    return false;
  }
  
  return true;
};

// Initialize Mapbox with token
export const initializeMapbox = () => {
  if (typeof window !== 'undefined' && validateMapboxToken()) {
    // Set global access token for mapbox-gl
    const mapboxgl = require('mapbox-gl');
    mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;
    return true;
  }
  return false;
};